import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetAllNotification, GetLiveNotificationBySME } from '../services/awsServices';


const initialState = {
    notifications: [],
    getAllNotification:[]
}

// export const registerUser = createAsyncThunk(
//     "auth/registerUser",
//     async (data, thunkAPI) => {
//       try {
//         console.log(data, "dataaaaaaaaa");
//         let response = await auth.register(data);
//         return response.data;
//       } catch (err) {
//         return thunkAPI.rejectWithValue(err);
//       }
//     }
// );

export const getAllNotification = createAsyncThunk(
    "socket/setWebSocket",
    async (_, thunkAPI) => {
        try {
            console.log("setWebSocket");
            let response = GetAllNotification()
            console.log(response,"response--dataaaa")
            return response;
        } catch (err) {
            return thunkAPI.rejectWithValue(err);
        }
    }
);

export const getAllNotificationRequestedBySme = createAsyncThunk(
    "socket/getAllNotificationRequestedBySme",
    async (_, thunkAPI) => {
        try {
            console.log("setWebSocket");
            let response = GetLiveNotificationBySME()
            console.log(response,"response--dataaaa")
            return response;
        } catch (err) {
            return thunkAPI.rejectWithValue(err);
        }
    }
);

const socketSlice = createSlice({
    initialState,
    name: "socket",
    reducers: {
        setWebSocketReducer: (state, action) => {
            state.websocket = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAllNotification.fulfilled, (state, action) => {

            state.notifications = action.payload.data.data;
        });
        builder.addCase(getAllNotificationRequestedBySme.fulfilled, (state, action) => {
            console.log(action.payload, 'payload-gettting-notification')

            state.getAllNotification = action.payload.data.data;
        });
    },
});


export const { setWebSocketReducer, } = socketSlice.actions;
export default socketSlice.reducer;